
import {HttpEAD,HttpCase} from "../Http";
export class VisaCareEADAPI {

 

  
  public static  EADCase(input: any){
    
 
    var obj = JSON.stringify(input);
 
    var url = "eadpetition/create";
  
  
    
    const resultMethod = HttpEAD.axios()
      .post(url ,obj,{
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
        return res;
 
      })
      
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;  

    
  }

  public static  getEADPetition(input: any){
    var url = "eadpetition/getEadPetitionDetailsByCaseId/"+input.input;
   if(input.inputParam==="CFI"){
      url = "eadpetition/getEadPetitionDetailsByCaseIdAndPetitionDetailsType/"+input.input+"?petitionDetailsType="+input.inputParam;
  } 
    const resultMethod = HttpEAD.axios().get(url, 
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
       
        return res;
      }).catch((e: any) => {
     
        return e.response;
      });
    return resultMethod;
    }


  public static   createEADPetition  (input: any){
    var url = "eadpetition/create";
    var obj=JSON.stringify(input.input);  
 
    if (input ==="") {
      return { data: [] };
    }
    const resultMethod = HttpEAD.axios().post(url, obj,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
       
        return res;
      }).catch((e: any) => {
      
        return e.response;
      });
    return resultMethod;
  }
  
  public static  updateEADPetition(input: any){
  var url = "eadpetition/update";
   
  var obj=JSON.stringify(input.input);   
 
  if (input ==="") {
    return { data: [] };
  }

  const resultMethod = HttpEAD.axios().put(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
    
      return res;
    }).catch((e: any) => {
   
      return e.response;
    });
  return resultMethod;
  }

  public static   eadPdfFormSubmit  (input: any){
    var url = "/caseflow/generateEadPetition/"+input.input;
   
 
    if (input ==="") {
      return { data: [] };
    }
    const resultMethod = HttpCase.axios().post(url,
      {
        headers: {
          'Content-Type': 'application/json',
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
      return res;
 /*
        var filename = res.data.outputPdfFilename;
        filename = filename.substring(filename.lastIndexOf('/') + 1);
        var obj = {
            "companyCode": res.data.companyCode,
            "caseId": res.data.caseId
        };
        var urlName = 'fileupload/getFile/' + filename;
         
        HttpUpload.axios().get(urlName , {params: obj, responseType: 'blob' }
        ).then(response => response.data)
            .then(blob => {
  
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                a.remove();
                
            })*/
      }).catch((e: any) => {
      
        return e.response;
      });
    return resultMethod;
  }
}